import * as mutations from './mutationNames';

export default {
    /**
     * Used for login purposes. Sets 2 keys: maps API key (apiKey)
     * and MoMa Panorama API key (momaKey).
     */
    [mutations.SET_KEYS]: (state, { apiKey, momaKey }) => {
        state.apiKey = apiKey;
        state.momaKey = momaKey;
    },

    /**
     * Used to log out/clear authentication data.
     */
    [mutations.CLEAR_KEYS]: (state) => {
        state.apiKey = null;
        state.momaKey = null;
    },
};
